import React from 'react';
import { useSelector } from 'react-redux';
import Modal from '@mui/material/Modal';
import { multipleRewardsChoicesModalStyles as styles } from './multipleRewardsChoicesModal.tailwind';
import CloseIcon from '@mui/icons-material/Close';
import redeem_rewards from '../../../../assets/svgs/redeem_reward.svg';

import r1 from '../../../../assets/rewards/r1.png';
import r2 from '../../../../assets/rewards/r2.png';
import r3 from '../../../../assets/rewards/r3.png';
import r4 from '../../../../assets/rewards/r4.png';
import r5 from '../../../../assets/rewards/r5.png';
import r6 from '../../../../assets/rewards/r6.png';
import r7 from '../../../../assets/rewards/r7.png';
import r8 from '../../../../assets/rewards/r8.png';
import r9 from '../../../../assets/rewards/r9.png';
import r10 from '../../../../assets/rewards/r10.png';
import r11 from '../../../../assets/rewards/r11.png';
import r12 from '../../../../assets/rewards/r12.png';
import r13 from '../../../../assets/rewards/r13.png';
import r14 from '../../../../assets/rewards/r14.png';
import r15 from '../../../../assets/rewards/r15.png';
import r16 from '../../../../assets/rewards/r16.png';
import r17 from '../../../../assets/rewards/r17.png';
import r18 from '../../../../assets/rewards/r18.png';

const MultipleRewardsChoicesModal = ({ isOpen, onClose, onClaim, reward }) => {
    const { claimingReward } = useSelector(state => state.reward);

    const staticOptions = [
        { id: 1, title: 'Reward Choice 1', image: r1 },
        { id: 2, title: 'Reward Choice 2', image: r2 },
        { id: 3, title: 'Reward Choice 3', image: r3 },
        { id: 4, title: 'Reward Choice 4', image: r4 },
        { id: 5, title: 'Reward Choice 5', image: r5 },
        { id: 6, title: 'Reward Choice 6', image: r6 },
        { id: 7, title: 'Reward Choice 7', image: r7 },
        { id: 8, title: 'Reward Choice 8', image: r8 },
        { id: 9, title: 'Reward Choice 9', image: r9 },
        { id: 10, title: 'Reward Choice 10', image: r10 },
        { id: 11, title: 'Reward Choice 11', image: r11 },
        { id: 12, title: 'Reward Choice 12', image: r12 },
        { id: 13, title: 'Reward Choice 13', image: r13 },
        { id: 14, title: 'Reward Choice 14', image: r14 },
        // { id: 15, title: 'Reward Choice 15', image: r15 },
        { id: 16, title: 'Reward Choice 16', image: r16 },
        // { id: 17, title: 'Reward Choice 17', image: r17 },
        { id: 18, title: 'Reward Choice 18', image: r18 },
    ];

    const handleDoubleClick = (option) => {
        if (!claimingReward) {
            onClaim();
        }
    };

    return (
        <Modal
            open={isOpen}
            onClose={onClose}
            disableAutoFocus
        >
            <div className={styles.container}>
                <div className={styles.closeIconContainer} onClick={onClose}>
                    <CloseIcon sx={{ fontSize: '16px' }} />
                </div>
                <div className={styles.popupheading}>
                    <img src={redeem_rewards} alt="redeem_rewards" className={styles.redeem_rewards}></img>
                    <div className={styles.heading}>Choose Your Reward</div>
                </div>
                <div className={styles.description}>
                    Double-click on an option below to redeem <span className={styles.highlightedText}>{reward?.rewardTitle}</span> for <span className={styles.highlightedText}>{reward?.pointsValue}</span> points.
                </div>

                <div className={styles.gridContainer}>
                    {staticOptions.map((option) => (
                        <div
                            key={option.id}
                            className={styles.optionCard}
                            onDoubleClick={() => handleDoubleClick(option)}
                        >
                            <img src={option.image} alt={option.title} className={styles.optionImage} />
                            {/* <div className={styles.optionTitle}>{option.title}</div> */}
                            {/* <div className={styles.instructionText}>
                                {claimingReward ? 'Redeeming...' : 'Double-click to claim'}
                            </div> */}
                        </div>
                    ))}
                </div>
            </div>
        </Modal>
    );
}

export default MultipleRewardsChoicesModal;
